import React from 'react'

const AccountComponent = () => {
  return <div>AccountComponent</div>
}

export default AccountComponent
